const n = (t) => {
  if (!t) return "";
  try {
    const e = new URL(t);
    return e.hostname === "youtu.be" ? e.pathname.slice(1) : new URLSearchParams(e.search).get("v");
  } catch (e) {
    return console.error("無效的 YouTube URL:", e), null;
  }
}, c = (t) => {
  if (!t) return "";
  try {
    const e = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(\d+)/, r = t.match(e);
    return r ? r[1] : null;
  } catch (e) {
    return console.error("无效的 Vimeo URL:", e), null;
  }
}, s = (t) => {
  const e = t * 8, r = 30 * 1e3 * 1e3, o = e / r;
  return Number(o.toFixed(2));
}, a = (t) => URL.createObjectURL(t);
export {
  s as getEstimateUploadTimeInSeconds,
  a as getVideoUrl,
  c as getVimeoVideoId,
  n as getYoutubeVideoId
};
